<app-header></app-header>
<section>
    <div class="container-fluid">

        <div class="row pt-5">
            <div class="col-11 col-md-10 col-lg-8 mx-auto card pt-2 px-3">
                <div class="row">
                    <div class="col-12 my-2">
                        <div class="card">
                            <div class="card-header">
                                Buscar su denuncia
                            </div>
                            <form [formGroup]="buscarForm">
                                <div class="card-body">
                                    <div class="div form-group">
                                        <input type="text" class="form-control" placeholder="Código de Denuncia"
                                            formControlName="codigo">
                                    </div>
                                    <div class="div form-group">
                                        <input type="text" class="form-control mt-2" placeholder="Correo electrónico"
                                            formControlName="correo">
                                    </div>
                                    <div class="div form-group">
                                        <input type="text" class="form-control mt-2" placeholder="Token"
                                            formControlName="token">
                                    </div>
                                    <div class="div form-group">
                                        <input type="text" class="form-control mt-2" placeholder="Teléfono"
                                            formControlName="fono">
                                    </div>
                                </div>
                                <div class="card-footer">
                                    <div class="d-md-flex float-end justify-content-end">
                                        <button class="btn btn-primary mt-2 mb-md-2" (click)="buscarDenuncia()">Buscar su Denuncia</button>

                                        <button class="btn btn-primary my-2 ms-md-2" (click)="cancelar()">Volver a Home</button>
                                    </div>
                                </div>
                            </form>
                        </div>
                    </div>
                </div>
                <ng-container *ngIf="busqueda">
                    <ng-container *ngIf="denuncia;else sinResultados">
                        <div class="mat-elevation-z8 m-2 mb-4 w-100 overflow-auto">
                            <table mat-table matSort [dataSource]="dataSource" multiTemplateDataRows  style="width: 100%">
                                <ng-container matColumnDef="id">
                                    <th mat-header-cell style="min-width: 150px" *matHeaderCellDef mat-sort-header>
                                        ID
                                    </th>
                                    <td mat-cell *matCellDef="let element">{{ element.id }}</td>
                                </ng-container>
                                <ng-container matColumnDef="fechaIngreso">
                                    <th mat-header-cell style="min-width: 150px" *matHeaderCellDef mat-sort-header>
                                        Fecha Ingreso
                                    </th>
                                    <td mat-cell *matCellDef="let element">{{ formatoFecha(element.fechaIngreso) }}</td>
                                </ng-container>
                                <ng-container matColumnDef="estado">
                                    <th mat-header-cell style="min-width: 150px" *matHeaderCellDef mat-sort-header>
                                        Estado
                                    </th>
                                    <td mat-cell *matCellDef="let element">{{ element.estado }}</td>
                                </ng-container>
                                <ng-container matColumnDef="fechaResolucion">
                                    <th mat-header-cell style="min-width: 150px" *matHeaderCellDef mat-sort-header>
                                        Fecha Resolución
                                    </th>
                                    <td mat-cell *matCellDef="let element">{{ formatoFecha(element.fechaResolucion) }}</td>
                                </ng-container>
                                <!--<ng-container matColumnDef="documentacionAnexa">
                                    <th mat-header-cell style="min-width: 150px" *matHeaderCellDef mat-sort-header>
                                        Documentación Anexa
                                    </th>
                                    <td mat-cell *matCellDef="let element">{{element.documentacionAnexa}}</td>
                                </ng-container>--> 
                              <ng-container matColumnDef="opciones">
                                    <th mat-header-cell style="min-width: 150px" *matHeaderCellDef>
                                        Opciones
                                    </th>
                                    <td mat-cell *matCellDef="let element">
                                        <a [routerLink]="['/detalle', element.id]" class="mx-1" matTooltip="Ver Detalle Denuncia">
                                            <img src="../assets/img/lupa-negra.svg" style="height: 20px; width: auto" />
                                        </a>
                                    </td>
                                </ng-container> 
                                <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
                                <tr mat-row *matRowDef="let row; columns: displayedColumns" class="example-element-row"
                                    [class.example-expanded-row]="row.expanded"></tr>
                            </table>
                        </div>
                    </ng-container>
                    <ng-template #sinResultados>No existen registros para esta consulta</ng-template>
                </ng-container>
            </div>
        </div>
    </div>
</section>